<template>
    <div class="th-popup flex flex-col gap-8" >
        <div class="th-popup-header relative bg-popup flex flex-col gap-8 p-16 items-center justify-between" v-if="poi">
			<img :src="poi.getIconUrl()" v-if="poi.getIconUrl()" class="w-70 h-40 object-contain"/>
            <label class="poi-name text-24" v-html="poi.getName(language)" @click="onPOIClick(poi)" style="height: 2.5em"></label>
            <!--label class="bg-neutral p-4 px-6 text-12 pt-6 rounded-md">
                {{ getFirstGroup(poi) }}
            </label-->

            <div class="absolute top-0 right-0 text-primary p-12" @click="close">
                <WFIcon name="close" class="w-14 h-14"></WFIcon>
            </div>

        </div>
        <div class="th-popup-body px-8 flex flex-col gap-8 justify-evenly" v-if="poi">
            <WFScrollableArea ref="scroll" class="scrollarea w-full h-100 grow-1 shrink-0">
                <div class="text-left font-normal" v-html="poi.getDescription(language)" v-show="!!poi.getDescription(language)"></div>
            </WFScrollableArea>

            <button class="btn poi-floor flex items-center justify-center p-12 leading-normal text-20 bg-active text-primary-content rounded-sm"  v-touch:tap="showPath()" v-if="poi.getFloor()">
                <WFTranslate k="show_path" class="pt-2 leading-normal text-16"></WFTranslate>
            </button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { WFIcon, WFTranslate } from '@3dwayfinder/wayfinder-vue-components'


export default {
    components: {
        WFTranslate,
        WFIcon
    },
    props: {
        poi: {
            default: null,
            type: Object
        }
    },
	computed: {
		...mapState('wf', ['language', 'currentPOI']),
	},
    watch: {
        currentPOI () {
            if(this.$refs.scroll) {
                this.$nextTick(() => {
                    this.$refs.scroll.resize();
                });                
            }
        }
    },
    methods: {
        getFirstGroup(poi) {
            if(typeof poi === "object") {
                return poi.getGroupNames(this.language).length > 0 ? poi.getGroupNames(this.language)[0] : '';
            }

            return "";
        },
        close () {
            this.$emit("close")
        },
        showPath () {
            return () => {
                this.$emit("close");
                this.$emit("showPath", this.poi);
            }
            
        },
        resize() {
           
            if(this.$refs.scroll) {
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        this.$refs.scroll.resize();
                    });
                });                
            }
        }
    }

}
</script>

<style>
.scrollarea {
    height: 10rem !important;
    overflow: hidden;
}
</style>
